import * as React from "react";

import { DefaultLayout } from "#components/default-layout";

import { useTranslation } from "react-i18next";
import { FinancialFileTable } from "./components/financial-financial-file-table/financial-financial-file-table";
import { FinancialFileProvider } from "./financial-file-context";
import s from "./financial-file.scss";

interface IFinancialFile {
	routeParams: GlobalTypes.RouteParams;
}

export const FinancialFile: React.FC<IFinancialFile> = ({ routeParams }) => {
	const placeId = routeParams.placeId;
	const { t } = useTranslation("place", { keyPrefix: "financialFile" });

	return (
		<DefaultLayout>
			<FinancialFileProvider placeId={placeId as string}>
				<div className={s.container}>
					<header className={s.header}>
						<div className={s.info}>
							<h1 className={s.title}>{t($ => $.title)}</h1>

							<p className={s.description}>{t($ => $.description)}</p>
						</div>
					</header>
					<FinancialFileTable />
				</div>
			</FinancialFileProvider>
		</DefaultLayout>
	);
};
